import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/dashboard" className="navbar-brand">
          Issue Tracker
        </Link>

        <ul className="navbar-nav">
          {user?.role === 'Admin' ? (
            <>
              <li>
                <Link 
                  to="/admin/dashboard" 
                  className={`nav-link admin-nav ${isActive('/admin/dashboard') ? 'active' : ''}`}
                >
                  🛡️ Admin Dashboard
                </Link>
              </li>
              <li>
                <Link 
                  to="/admin/users" 
                  className={`nav-link admin-nav ${isActive('/admin/users') ? 'active' : ''}`}
                >
                  👥 User Management
                </Link>
              </li>
              <li>
                <Link 
                  to="/issues" 
                  className={`nav-link ${isActive('/issues') ? 'active' : ''}`}
                >
                  📋 All Issues
                </Link>
              </li>
              <li>
                <Link 
                  to="/activities" 
                  className={`nav-link ${isActive('/activities') ? 'active' : ''}`}
                >
                  📊 System Activity
                </Link>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link 
                  to="/dashboard" 
                  className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                >
                  📊 Dashboard
                </Link>
              </li>
              <li>
                <Link 
                  to="/issues" 
                  className={`nav-link ${isActive('/issues') ? 'active' : ''}`}
                >
                  📋 Issues
                </Link>
              </li>
              <li>
                <Link 
                  to="/create-issue" 
                  className={`nav-link ${isActive('/create-issue') ? 'active' : ''}`}
                >
                  ➕ Create Issue
                </Link>
              </li>
              <li>
                <Link 
                  to="/activities" 
                  className={`nav-link ${isActive('/activities') ? 'active' : ''}`}
                >
                  ⚡ Activities
                </Link>
              </li>
            </>
          )}
        </ul>

        <div className="user-menu">
          <div className="user-info">
            <div className="flex items-center gap-2">
              <span>{user?.first_name} {user?.last_name}</span>
              <span className="user-role">{user?.role}</span>
            </div>
          </div>
          <Link to="/profile" className="btn btn-outline btn-sm">
            Profile
          </Link>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 